<template>
    <div>
        <Head title="Find and Appointment" />
        <!-- Start Hero -->
        <section class="relative z-10 overflow-hidden bg-primary pt-[120px] pb-[100px] md:pt-[130px] lg:pt-[160px]">

            <div class="container">
                <div class="-mx-4 flex flex-wrap items-center">
                    <div class="w-full px-4">
                        <div class="text-center text-white">
                            <h1 class="text-4xl font-semibold ">{{ __('Make an appointment') }}</h1>
                            <p class="mt-2 text-base leading-7">{{ __('Select people to set schedule.') }}</p>
                        </div>
                    </div>
                </div><!--end grid-->
            </div><!--end container-->

            <div>
                <span class="absolute top-0 left-0 z-[-1]">
                    <img src="/landing/images/header/shape-1.svg" alt="" />
                </span>
                <span class="absolute top-0 right-0 z-[-1]">
                    <img src="/landing/images/header/shape-2.svg" alt="" />
                </span>
            </div>

        </section>


        <section class="pt-20 pb-10 lg:pt-[70px] lg:pb-20">
            <div class="container">
                <form class="flex justify-center items-center w-full pb-12">
                    <div class="flex w-full max-w-2xl">
                        <label for="search-dropdown" class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Your Email</label>
                        <div class="flex-shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-l-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600" type="button">
                            <select v-model="form.profession" class="bg-transparent" name="profession" aria-label="Select category">
                                <option value="">Select category</option>
                                <option v-for="(profession, pi) in $page.props.professions" :key="pi" :value="profession.slug">{{ profession.name }}</option>
                            </select>
                        </div>
                        <div class="relative w-full">
                            <input type="search" id="search-dropdown" class="block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-r-lg border-l-gray-50 border-l-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-l-gray-700  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500" placeholder="Search Mockups, Logos, Design Templates..." required>
                            <button type="submit" class="absolute top-0 right-0 p-2.5 text-sm font-medium text-white bg-blue-700 rounded-r-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                <svg aria-hidden="true" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
                                <span class="sr-only">Search</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="container">
                <!-- New Code -->
                <div class="flex flex-col mt-8">
                    <div class="container max-w-7xl px-4">
                        <div class="flex flex-wrap">
                            <!-- Member #1 -->
                            <div v-for="user in users.data" :key="user.id" class="w-full md:w-6/12 lg:w-3/12 mb-12 px-6 sm:px-6 lg:px-4">
                                <div class="flex flex-col">
                                    <!-- Avatar -->
                                    <a href="#" class="mx-auto">
                                        <img v-if="user.photo_path" :src="user.photo_path" class="rounded-2xl drop-shadow-md hover:drop-shadow-xl transition-all duration-200 delay-100" alt="">
                                        <img v-else src="/images/svg/profile.svg" class="rounded-2xl drop-shadow-md hover:drop-shadow-xl transition-all duration-200 delay-100" alt="">
                                    </a>

                                    <!-- Details -->
                                    <div class="text-center mt-6">
                                        <!-- Name -->
                                        <h1 class="text-gray-900 text-xl font-bold mb-1">
                                            <a :href="route('schedule.user', user.username)">{{ user.first_name }} {{ user.last_name }}</a>
                                        </h1>

                                        <!-- Title -->
                                        <div class="text-gray-700 font-light mb-2">
                                            {{ user.profession }}
                                        </div>

                                        <!-- Social Icons -->

                                        <a v-if="user.event_types.length" v-for="event_type in user.event_types" :href="route('schedule.user', user.username)" class="bg-gray-100 dark:bg-gray-800 text-slate-400 text-xs font-medium px-3 py-1 rounded-lg h-[24px] inline-block m-1">{{ event_type.duration.replace('_', ' ') }}</a>
                                        <span v-else class="bg-gray-100 dark:bg-gray-800 text-slate-400 text-xs font-medium px-3 py-1 rounded-lg h-[24px] inline-block m-1">no schedule option</span>

                                        <p class="text-slate-400 mt-4" v-html="user.details.substr(0, 65)+'...'"></p>
                                        <div class="mt-4">
                                            <a :href="route('schedule.user', user.username)" class="text-primary hover:underline w-full">Schedule Page</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- New Code -->
                <div class="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-[30px]">
                    <!-- Start Candidate Content -->
<!--                    <div v-for="user in users.data" :key="user.id" class="group relative p-6 rounded-md shadow dark:shadow-gray-800 hover:shadow-md dark:hover:shadow-gray-700 bg-white dark:bg-slate-900 transition duration-500 text-center">-->
<!--                        &lt;!&ndash; team p-6 rounded-md shadow-md dark:shadow-gray-800 dark:border-gray-700 bg-white dark:bg-slate-900 relative &ndash;&gt;-->
<!--                        <div class="absolute inset-0 bg-red-600/10 dark:bg-indigo-600/30 rounded-md -mt-[20px] ltr:-ml-[20px] rtl:-mr-[20px] h-[98%] w-[98%] -z-1"></div>-->
<!--                        <div class="mt-8 mb-3">-->
<!--                            <img v-if="user.photo_path" :src="user.photo_path" class="rounded-full shadow-md h-20 w-20 mx-auto block" alt="">-->
<!--                            <img v-else src="/images/svg/profile.svg" class="rounded-full shadow-md h-20 w-20 mx-auto block" alt="">-->
<!--                            <div class="mt-3">-->
<!--                                <a :href="route('schedule.user', user.username)" class="text-lg font-medium hover:text-indigo-600 transition duration-500 block">{{ user.first_name }} {{ user.last_name }}</a>-->
<!--                                <span class="block text-sm text-slate-400">{{ user.profession }}</span>-->
<!--                            </div>-->
<!--                        </div>-->

<!--&lt;!&ndash;                        <div class="flex items-center justify-around my-4">&ndash;&gt;-->
<!--&lt;!&ndash;                            <span class="text-slate-400"><i class="uil uil-map-marker text-indigo-600 ltr:mr-1 rtl:ml-1"></i>London</span>&ndash;&gt;-->
<!--&lt;!&ndash;                            <span class="text-slate-400"><i class="uil uil-dollar-sign text-indigo-600 ltr:mr-1 rtl:ml-1"></i>3300/mo</span>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->


<!--                        <a v-if="user.event_types.length" v-for="event_type in user.event_types" :href="route('schedule.user', user.username)" class="bg-gray-100 dark:bg-gray-800 text-slate-400 text-xs font-medium px-3 py-1 rounded-lg h-[24px] inline-block m-1">{{ event_type.duration.replace('_', ' ') }}</a>-->
<!--                        <span v-else class="bg-gray-100 dark:bg-gray-800 text-slate-400 text-xs font-medium px-3 py-1 rounded-lg h-[24px] inline-block m-1">no schedule option</span>-->
<!--                        <p class="text-slate-400 mt-4" v-html="user.details.substr(0, 65)+'...'"></p>-->
<!--                        <div class="mt-4">-->
<!--                            <a :href="route('schedule.user', user.username)" class="btn bg-indigo-600/5 hover:bg-indigo-600 border-indigo-600/10 hover:border-indigo-600 text-indigo-600 hover:text-white rounded-md w-full">View Schedule Page</a>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>

                <pagination class="mt-6" :links="users.links" />

            </div><!--end container-->
        </section><!--end section-->
<!--        <section class="relative md:py-20 py-16">-->
<!--            <div class="container">-->
<!--                <div class="md:flex justify-center">-->
<!--                    <div class="md:w-full">-->
<!--                        <div class="p-6 bg-white rounded-md leading-7 html" v-html="sanitizeHtml(page.content)">-->


<!--                        </div>-->
<!--                    </div>&lt;!&ndash;end &ndash;&gt;-->
<!--                </div>&lt;!&ndash;end grid&ndash;&gt;-->
<!--            </div>&lt;!&ndash;end container&ndash;&gt;-->
<!--        </section>&lt;!&ndash;end section&ndash;&gt;-->
        <!-- End Terms & Conditions -->
    </div>
</template>
<script>
import Layout from '@/Shared/Landing/Layout'
import Icon from '@/Shared/Icon'
import Pagination from '@/Shared/Landing/Pagination'
import { Head } from '@inertiajs/inertia-vue3'
import sanitizeHtml from "sanitize-html";
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
export default {
    layout: Layout,
    components: {
        Icon,
        Pagination,
        Head
    },
    props: {
        users: Object,
        filters: Object,
    },
    data() {
        return {
            durations: [
                {value: '15_min', name: '15 Minutes'},
                {value: '30_min', name: '30 Minutes'},
                {value: '45_min', name: '45 Minutes'},
                {value: '60_min', name: '60 Minutes'},
                {value: '2_hrs', name: '2 Hours'},
            ],
            form: {
                profession: this.filters.profession ?? '',
                duration: this.filters.duration ?? '',
                search: this.filters.search,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function() {
                this.$inertia.get(this.route('appointment'), pickBy(this.form), { replace: true, preserveState: true })
            }, 150),
        },
    },
    methods: {
        sanitizeHtml : sanitizeHtml
    },
    created() {
      console.log(this.filters)
    }
}
</script>
